import {
  collection,
  getDocs,
  doc,
  setDoc,
  getDoc,
  query,
  orderBy,
  where,
  deleteDoc,
  limit,
  Timestamp,
  startAfter,
  updateDoc,
} from "firebase/firestore";
// import { uploadFile } from "../../utils/uploadUtils";
import {
  USER_FETCH_SUCCESS,
  USER_SET,
  USER_RESET,
  USER_CREATE_SUCCESS,
  USER_CREATE,
  USER_CREATE_FAILURE,
} from "../actionTypes";
import { db } from "../../conf/firebase";

const usersRef = collection(db, "users");

// Get a user
export function getUser(uid) {
  return async (dispatch) => {
    try {
      const queryRef = query(usersRef, where("uid", "==", uid));
      const querySnapshot = await getDocs(queryRef); // Execute the query
      if (querySnapshot.empty) {
        throw new Error("No such document!");
      }
      const userDoc = querySnapshot.docs[0];
      const user = userDoc.data();
      dispatch({
        type: USER_FETCH_SUCCESS,
        payload: user,
      });
      return user;
    } catch (error) {
      console.log({ error });
      throw Error(error);
    }
  };
}

// Function to fetch single user by email
export function getUserByEmail(email) {
  return async (dispatch) => {
    try {
      const q = query(usersRef, where("email", "==", email));
      const docRefs = await getDocs(q); // 1 user read call
      if (docRefs.empty) {
        return null;
      }
      const user = docRefs.docs[0].data();
      await dispatch({ type: USER_FETCH_SUCCESS, payload: user });
      return user;
    } catch (error) {
      console.log({ error });
    }
  };
}

// Function to update user field values and update user reducer and update user in users reducer
// export function updateUser(userData) {
//   return async (dispatch, getState) => {
//     try {
//       let { users } = getState().authReducer.users;
//       let { auth } = getState().authReducer.auth;
//       if (userData.logo) {
//         if (userData.logo?.url instanceof File) {
//           let logo = userData;
//           if (userData.logo?.filepath) {
//             logo = await uploadFile(
//               userData.logo.url,
//               "users/company_logo",
//               userData.logo.filepath
//             ); // 1 storage write call
//           } else {
//             logo = await uploadFile(userData.logo.url, "users/company_logo"); // 1 storage write call
//           }
//           if (logo) userData.logo = logo;
//         }
//       }
//       if (!auth?.uid) return;
//       await updateDoc(doc(db, "users", auth?.uid), {
//         ...userData,
//         updated_at: Timestamp.now(),
//       }); // 1 user write call
//       await dispatch({ type: USER_SET, payload: userData });
//       if (auth?.uid) await dispatch(setAuth({ ...auth, ...userData }));
//       if (users.length > 0) {
//         users = users.map((usr) => (usr.uid === auth?.uid ? { ...userData } : usr));
//         await dispatch({ type: USERS_FETCH_SUCCESS, payload: { users } });
//       }
//     } catch (error) {
//       console.log({ error });
//     }
//   };
// }

// Function to update user's field values in reducer
export function setUser(userData) {
  return (dispatch) => {
    try {
      dispatch({ type: USER_SET, payload: userData });
    } catch (error) {
      console.log({ error });
    }
  };
}

// Function to reset user reducer to initial state
export function resetUser() {
  return (dispatch) => {
    try {
      dispatch({ type: USER_RESET });
    } catch (error) {
      console.log({ error });
    }
  };
}
